import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '/' },
  { label: '优惠券', href: '/category/coupon' },
  { label: '折扣活动', href: '/category/discount' },
  { label: '会员福利', href: '/category/member' },
  { label: '返利信息', href: '/category/rebate' },
  { label: '限时特惠', href: '/category/flash' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-gift-line text-xl text-white"></i>
          </div>
          <span className="text-xl font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
            福利导航网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href))
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="px-5 py-2 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href))
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium text-center"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}